import author from "@images/homepage/author.png";
import { ApiPostResponseItem } from "@/lib/api/content";
import { TPost } from "@template/components/PostCard";

const parseApiResponse = (item: ApiPostResponseItem): TPost => {
  const { article_title, author_name, publish_on, type_id, url, read_time } =
    item;
  const colorMap: Record<number, TPost["color"]> = {
    1: "primary",
    2: "default",
    3: "secondary",
  };
  const typeMap: Record<number, TPost["type"]> = {
    1: "blog",
    2: "faq",
    3: "news",
  };

  const isFaq = type_id == 2;
  const formattedUrl = isFaq ? url.replace(/^\/news\//, "/faq/") : url;
  // Faq links coming from the backend with /news/ in the slug, so we need to replace it with /faq/

  return {
    type: typeMap[type_id],
    title: article_title,
    author: author_name,
    authorDisplayPicture: author,
    url: formattedUrl,
    date: publish_on,
    color: colorMap[type_id],
    minutesToRead: read_time,
  };
};

export const transformPosts = (posts: ApiPostResponseItem[]): TPost[] => {
  return posts.map(parseApiResponse);
};
